import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
	ContactUpdateCompanyDiffEntryResource,
	ContactUpdateCompanyDiffRowResource,
} from "../../../../shared/types/contactUpdateInquiry";
import {
	ContactUpdateBaseRelationDiffRow,
	ContactUpdateInquiryDiffEntry,
	mapRelationEntry,
} from "./ContactUpdateBaseRelationDiffRow";
import { companyDiffEntryToIdentifier } from "./contactUpdateUtils";

interface Props {
	row: ContactUpdateCompanyDiffRowResource;
}

const Company: FC<ContactUpdateCompanyDiffEntryResource> = ({ name, position }) => {
	return (
		<div>
			<div>{name}</div>
			<div>{position}</div>
		</div>
	);
};

export const ContactUpdateCompanyDiffRow: FC<Props> = ({ row }) => {
	const { t } = useTranslation();
	const [field] = useField("companies");
	const value = field.value[companyDiffEntryToIdentifier(row.currentContact)];
	const identifier = companyDiffEntryToIdentifier(row.currentContact);

	const currentContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.currentContact),
		active: value === "currentContact",
		heading: t("Company"),
		value: <Company {...row.currentContact} />,
		onClick: () =>
			field.onChange({
				target: {
					name: field.name,
					value: { ...field.value, [identifier]: "currentContact" },
				},
			}),
	};

	const updatedContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.updatedContact),
		active: value === "updatedContact",
		heading: t("Company"),
		value: <Company {...row.updatedContact} />,
		onClick: () =>
			field.onChange({
				target: {
					name: field.name,
					value: { ...field.value, [identifier]: "updatedContact" },
				},
			}),
	};

	return <ContactUpdateBaseRelationDiffRow currentContact={currentContact} updatedContact={updatedContact} />;
};
